import React from 'react';

import * as S from './styles';

const Header: React.FC = ({ children, ...rest }) => {
  return <S.Header {...rest}>{children}</S.Header>;
};

export default Header;
